import React from "react";
import { UpcomingReleasesWidget } from "./UpcomingReleasesWidget";
import { useContractors } from "../../contexts/ContractorsContext";
import { InputSelect } from "../../components/InputSelect";
import { StringParam, useQueryParams, withDefault } from "use-query-params";
import { TopTracksPrevWeekWidget } from "./TopTracksPrevWeekWidget";
import { TopArtistsPrevWeekWidget } from "./TopArtistsPrevWeekWidget";
import { TopArtistsLastWeekWidget } from "./TopArtistsLastWeekWidget";
import { useTranslation } from "../../hooks/useTranslation";
import { TopVkAlbumWidget } from "./TopVkAlbumWidget";
import { TopVkReleaseWidget } from "./TopVkReleaseWidget";

export const DashboardPage: React.FC = () => {
  const { t } = useTranslation();
  const { contractors } = useContractors();
  const [query, setQuery] = useQueryParams({
    contractor_id: withDefault(StringParam, contractors?.length === 1 ? contractors[0].id as any : undefined)
  });

  return <>
    <div className={"flex gap-[18px] items-center"}>
      <div className={"font-bold text-2xl"}>
        {t("dashboard.dashboard")}
      </div>
      {
        contractors.length > 1 &&
        <InputSelect
          className={"max-w-[400px]"}
          placeholder={"Контрагент"}
          value={query.contractor_id ?? null}
          options={contractors?.map(c => {
            return {
              value: c.id,
              label: c.title
            };
          }) ?? []}
          onChange={(v) => setQuery({ contractor_id: v.value?.toString() })}
        />
      }
    </div>
    <div className={"flex w-full mt-[64px] gap-[12px]"}>
      <div className={"w-1/2"}>
        <UpcomingReleasesWidget contractorId={query.contractor_id} />
      </div>
      <div className={"w-1/2"}>
        <TopTracksPrevWeekWidget
          contractorId={query.contractor_id}
          contractors={contractors}
        />
      </div>
    </div>
    <div className={"flex w-full gap-[12px] mt-[12px]"}>
      <div className={"w-1/2"}>
        <TopArtistsPrevWeekWidget
          contractorId={query.contractor_id}
          contractors={contractors}
        />
      </div>
      <div className={"w-1/2"}>
        <TopVkReleaseWidget
          contractorId={query.contractor_id}
          contractors={contractors}
        />
      </div>
    </div>
    <div className={"flex w-full gap-[12px] mt-[12px]"}>
      <div className={"w-1/2"}>
        <TopVkAlbumWidget
          contractorId={query.contractor_id}
          contractors={contractors}
        />
      </div>
    </div>
  </>;
};
